import _ from 'lodash';
import { SkillGroup } from '../samwin-skills/skill-group';

export class MessageStatus {
   constructor(public isCreated: boolean, public isAssigned: boolean, public isOpened: boolean) {}
}

export class MessageInfo {
   messageId: string;
   callId: number;
   group: string;
   queueId: number;
   skill: SkillGroup;
   address: string;
   subject: string;
   memo: string;
   category: string;
   agent: string;
   timestamp: Date;
   messageStatus: MessageStatus;
   isSkillAvailable: boolean;
   hasNotSkillProgression: boolean;
   isParkedOnAgent: boolean;
   isParkedOnSkill: boolean;

   constructor(
      messageId: string,
      callId: number,
      group: string,
      skill: SkillGroup,
      address: string,
      subject: string,
      memo: string,
      agent: string,
      timestamp: Date,
      messageStatus: MessageStatus,
      skillId: number = 0,
      itemSkillValue: number = 100,
      isParkedOnAgent: boolean = false,
      isParkedOnSkill: boolean = false
   ) {
      this.messageId = messageId;
      this.callId = callId;
      this.group = group;
      this.skill = skill;
      this.address = address;
      this.subject = subject;
      this.memo = memo;
      this.agent = agent;
      this.timestamp = timestamp;
      this.queueId = skillId;
      const skillValue = _(skill?.skills).find((subskill) => subskill.skillId === skillId)?.skillUserConfiguration?.userSkillValue ?? -1;
      this.isSkillAvailable = skillValue >= itemSkillValue;
      this.hasNotSkillProgression = itemSkillValue > 10;
      this.isParkedOnAgent = isParkedOnAgent;
      this.isParkedOnSkill = isParkedOnSkill;
      this.messageStatus = messageStatus;
   }
}
